import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";

type TemplateVariableDeleteDialogProps = {
  open: boolean;
  error?: string;
  name: string;
  isPending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export function TemplateVariableDeleteDialog({
  open,
  error,
  name,
  isPending,
  onOpenChange,
  onConfirm,
}: TemplateVariableDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove variable</DialogTitle>
          <DialogDescription>
            Remove “{name}” and all of its configured child variables? This
            cannot be undone.
          </DialogDescription>
        </DialogHeader>
        {error && (
          <p role="alert" className="text-sm text-destructive">
            {error}
          </p>
        )}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            disabled={isPending}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={isPending}
            onClick={onConfirm}
          >
            {isPending ? "Removing…" : "Confirm remove"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
